import { Field, RadioGroup, TextOutput } from '../../Core';
import { ListFieldSection, PageSection } from '../../Layout';

const LiquidLimitApparatusEquipment = () => {
  return (
    <>
      <PageSection heading="Liquid Limit Apparatus">
        <ListFieldSection>
          <Field input={<TextOutput />} label="Liquid Limit Apparatus" name="Code" />
          <Field
            input={<RadioGroup />}
            label="Device Type"
            name="DeviceType"
            simpleValue
            options={[
              { label: 'Manual', value: 'Manual' },
              { label: 'Mechanical', value: 'Mechanical' },
            ]}
          />
        </ListFieldSection>
      </PageSection>
    </>
  );
};

export default LiquidLimitApparatusEquipment;
export { LiquidLimitApparatusEquipment };
